'use client';

import { DialogHeader } from '@packages/modules/src/Dialog/DialogHeader/DialogHeader.client';
import { Button } from '@packages/shared/src/ui/Button/Button';
import { Dialog } from '@packages/shared/src/ui/Dialog/Dialog';
import { DialogContent } from '@packages/shared/src/ui/Dialog/DialogContent/DialogContent';
import { useState } from 'react';
import { SoftHyphenInjector } from '../SoftHyphenInjector';
import type { ModalByButtonType } from './types';

/**
 * This component generates a button element that opens a modal layer when clicked.
 *
 * @param data Object contains data
 * @returns JSX.Element to be placed in PageLayout
 */
export const ModalByButton = ({ data }: { data: ModalByButtonType }) => {
  const {
    field_text: buttonLinkText,
    field_headline: modalHeadline = '',
    field_html_editor: modalContent,
    behavior_paragraph_size: behaviorSize,
    behavior_paragraph_layout: behaviorLayout,
  } = data;

  const [isDialogOpen, setIsDialogOpen] = useState(false);

  if (!modalContent) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <></>;
  }

  return (
    <>
      <Button
        onClick={() => {
          setIsDialogOpen(true);
        }}
        {...(behaviorSize && {
          size: behaviorSize,
        })}
        {...(behaviorLayout && {
          // runtime check if the value is a valid color - the cms may deliver invalid values
          color: [
            'default',
            'primary',
            'secondary',
            'additional',
            'success',
            'warning',
            'error',
            'sale',
          ].includes(behaviorLayout)
            ? behaviorLayout
            : undefined,
        })}
      >
        <SoftHyphenInjector text={buttonLinkText} />
      </Button>
      <Dialog
        isOpen={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false);
        }}
        title={modalHeadline}
      >
        <DialogHeader
          onClose={() => {
            setIsDialogOpen(false);
          }}
        >
          {modalHeadline}
        </DialogHeader>
        <DialogContent dangerouslySetInnerHTML={{ __html: modalContent }} />
      </Dialog>
    </>
  );
};
